"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function events() {
    return {
        load(state, actions) {
            actions.effects.importState();
        },
        changeTab(state, actions, { tabName }) {
            actions.setters.setTab({ tabName });
        },
        export(state, actions) {
            return actions.effects.exportState();
        },
    };
}
exports.events = events;
//# sourceMappingURL=events.js.map